import React, { useState, Component } from "react";
import { Card, Jumbotron, Container, Row, Col } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Clipboard } from "react-feather";
import yaml from "js-yaml";
import { encryptValue, getSealedSecret } from "@socialgouv/aes-gcm-rsa-oaep";

import "bootstrap/dist/css/bootstrap.min.css";

import { isValidKey } from "./isValidKey";
import { Form } from "./Form";
import { Protip } from "./Protip";
import { LoginForm } from "./Login";
// import ProtectedRoute from "./ProtectedRoute";
import ProtectedRoute from "./components/route/ProtectedRoute";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import Loadable from "react-loadable";
import Helper from "./util/Helper";
import GlobalError from "./components/common/GlobalError";
import EnvironmentService from "./service/environment/EnvironmentService";
import EnvironmentConfig from "./service/environment/EnvironmentConfig";
import AuthenticationService from "./service/auth/AuthenticationService";
import EventService from "./service/event/EventService";
import NoPageFound from "./modules/NoPageFound";
import "./styles/App.css";

const LoadingComponent = (props) => {
  if (props.error)
    return EventService.emit("showError", {
      message: "Error loading the module",
    });

  if (props.pastDelay) return <h3> loading... </h3>;
  return null;
};

const Login = Loadable({
  loader: () => import("./modules/user/components/Login"),
  loading: LoadingComponent,
});

const SelectTenant = Loadable({
  loader: () => import("./modules/user/components/SelectTenant"),
  loading: LoadingComponent,
});

const Editor = Loadable({
  loader: ()=> import("./components/editor/Editor"),
  loading: LoadingComponent,
})

// const Intro = () => (
//   <Jumbotron
//     style={{ marginTop: "1rem", marginBottom: "1rem", padding: "1rem 1rem" }}
//   >
//     <h1>WebSeal</h1>
//     <p>Client-side sealed-secrets generation</p>
//   </Jumbotron>
// );

// const CodeArea = (props) => (
//   <textarea
//     {...props}
//     style={{
//       fontSize: "0.8rem",
//       fontFamily: "Courier",
//       border: "1px solid #ccc",
//       width: "100%",
//       padding: 5,
//       height: 400,
//       ...(props.style || {}),
//     }}
//   ></textarea>
// );

// const Copier = ({ text }) => {
//   const [copied, setCopied] = useState(false);
//   return (
//     <CopyToClipboard
//       text={text}
//       onCopy={() => {
//         setCopied(true);
//         setTimeout(() => setCopied(false), 2000);
//       }}
//     >
//       <Clipboard
//         style={{
//           marginLeft: 10,
//           cursor: "pointer",
//           transition: "all 0.2s ease-in",
//         }}
//         color={copied ? "green" : "black"}
//         title="Copy"
//         size={16}
//       />
//     </CopyToClipboard>
//   );
// };

// const Editor = () => {
//   const [formData, setFormData] = useState({
//     cluster: "dev",
//     namespace: "",
//     name: "",
//     pemKey: "",
//   });
//   const [encrypted, setEncrypted] = useState(null);
//   const [yamlResult, setYamlResult] = useState(null);
//   const onSubmit = async (data) => {
//     //console.log("onSubmit2", data);
//     const validKey = isValidKey(data.pemKey);
//     setFormData(data);
//     setEncrypted("");
//     setYamlResult("");
//     if (!validKey) {
//       return;
//     }
//     if (data.value && data.value !== formData.value) {
//       const pemKey = data.pemKey;
//       const values = {};
//       if (data.value.match(/^([\w_-\d]+)=(.+)$/im)) {
//         data.value.split("\n").forEach((row) => {
//           const matches = row.match(/^([\w_-\d]+)=(.*)$/i);
//           if (matches) {
//             values[matches[1]] = matches[2];
//           }
//         });
//       } else {
//         values.VALUE = data.value;
//       }
//       let sealedSecret;
//       try {
//         sealedSecret = await getSealedSecret({
//           pemKey,
//           namespace: data.namespace || "some-namespace",
//           name: data.name || "some-secret-name",
//           scope: data.scope,
//           values,
//         });
//       } catch (e) {
//         console.log("cannot create sealed secret", e.message);
//         return;
//       }
//       if (data.scope === "strict" && (!data.namespace || !data.name)) {
//         console.log("namespace and name are mandatory");
//         setYamlResult("");
//         setEncrypted("");
//       } else if (data.scope === "namespace" && !data.namespace) {
//         console.log("namespace is mandatory");
//         setYamlResult("");
//         setEncrypted("");
//       } else if (!data.value) {
//         console.log("value is mandatory");
//         setYamlResult("");
//         setEncrypted("");
//       } else {
//         const keys = Object.keys(values);
//         if (keys.length === 1) {
//           setEncrypted(sealedSecret.spec.encryptedData[keys[0]]);
//         } else {
//           setEncrypted(
//             "Not available for multiple values, use the below secret"
//           );
//         }
//         setYamlResult(yaml.dump(sealedSecret, { noRefs: true, lineWidth: -1 }));
//       }
//     }
//   };
//   return (
//     <Container>
//       <Intro />
//       <Row>
//         <Col xs={12}>
//           <Form onSubmit={onSubmit} initialFormData={formData} />
//           {encrypted && (
//             <>
//               <Card style={{ marginTop: 10 }}>
//                 <Card.Body>
//                   <Card.Title>
//                     SealedSecret <Copier text={yamlResult} />
//                   </Card.Title>
//                   <CodeArea defaultValue={yamlResult} />
//                 </Card.Body>
//               </Card>
//               <Protip />
//               <br />
//               <br />
//             </>
//           )}
//         </Col>
//       </Row>
//     </Container>
//   );
// };


// const handleLogin = async ({ username, password }) => {

//   const formData = new FormData();
//     formData.append('username', username);
//     formData.append('password', password);
//   const response = await fetch("https://services.dev1.zyla.in/v1/messaging/auth/user", {
//     method: "POST",
//     body: formData,
//   });
  
//   const data = await response.text()
//   console.log("data: ", data);

//   if (data=="deny") {
//     throw new Error(data.message || "Login failed");
//   }

//   // Save token locally (optional)
//   localStorage.setItem("token", data.token);

//   // Show success or redirect
//   alert("Login successful!");

//   window.location.href = "/";
// };

// export default function App() {
//   return (
//     // <div className="App">
//     //   {/* <Editor /> */}
//     //   <LoginForm onLogin={handleLogin} />
//     // </div>
//     <Router>
//       <Switch>
//         {/* <Route path="/login" render={() => <LoginForm onLogin={handleLogin} />} /> */}
//         <Route
//           path="/login"
//           render={({ location }) =>
//             localStorage.getItem("token") ? (
//               <Redirect to={{ pathname: "/", state: { from: location } }} />
//             ) : (
//               <LoginForm onLogin={handleLogin} />
//             )
//           }
//         />
//         <ProtectedRoute exact path="/" component={Editor} />
//         <Redirect to="/login" />
//       </Switch>
//     </Router>
//   );
// }

class App extends Component {
  constructor() {
    super();
    this.environment = this.getEnvironment();
    this.environmentService = new EnvironmentService();
    this.environmentService.set(this.environment);

    this.authenticationService = new AuthenticationService();
    this.helper = new Helper();

    this.search = new URLSearchParams(window.location.search);

    // initialize Google Analytics only if production
    if (this.environmentService.isProduction()) {
      ReactGA.initialize("UA-96177847-2");
      this.logPageView();
    }

    this.state = {
      user: this.authenticationService.getUserProfile(),
      who: this.getWhoLoggedIn(),
    };
  }
  getWhoLoggedIn() {
    const user = this.authenticationService.getUserProfile();
    let who = "EMPLOYEE";
    if (user && user.patientProfile && user.patientProfile.id > 0) {
      who = "PATIENT";
    } else if (user && user.employeeProfile && user.employeeProfile.id > 0) {
      who = "EMPLOYEE";
    } else if (
      user &&
      user.employeeProfile &&
      user.employeeProfile.id > 0 &&
      user.doctorProfile &&
      user.doctorProfile.id > 0
    ) {
      who = "EMPLOYEE";
    } else if (user && user.doctorProfile && user.doctorProfile.id > 0) {
      who = "DOCTOR";
    } else {
      who = "EMPLOYEE";
    }
    return who;
  }
  componentWillMount() {
    this.getWhoLoggedIn();
    this.setState({
      user: this.authenticationService.getUserProfile(),
      who: this.getWhoLoggedIn(),
    });
  }

  
  getEnvironment() {
    let config = EnvironmentConfig;
    let originUrl = window.location.hostname;

    if (
      window.location.hostname == "dev1.bridge.zyla.in" ||
      window.location.hostname == "dev1-sy-bridge.zyla.in" ||
      window.location.hostname == "dev3-bridge.zyla.in" ||
      window.location.hostname == "staging-sy-bridge.zyla.in"
    ) {
      return "staging";
    }
    if (
      window.location.hostname == "bridge.zyla.in" ||
      window.location.hostname == "bridge.prod.zyla.in" ||
      window.location.hostname == "sy-bridge.zyla.in"
    ) {
      return "production";
    }

    for (var environment in config.vars) {
      let domain = config.vars[environment].domain;
      if (domain == originUrl) {
        return config.environments[environment];
      }
    }
  }

  logPageView() {
    ReactGA.set({ page: "home" });
    ReactGA.pageview("home");
  }

  render() {
    const updateStatus = localStorage.getItem("updateStatus");
    const updateMessage = localStorage.getItem("updateMessage");
    const { who } = this.state;

    return (
      <div className="App">
        <Router>
            <div>
              <Switch>
                <Route path="/tenant" component={SelectTenant} />
                <Route path="/login" component={Login} />
                <Route path="/not-found" exact component={NoPageFound} />
                <ProtectedRoute
                  path="/"
                  component={Editor}
                  authenticator={this._authenticator}
                  redirectTo={"/login"}
                />
                <Route path="/">
                  <div>

                    {who && who === "EMPLOYEE" && (
                      // <Drawer>
                        <div className="container-main">
                          
                          {/* <ProtectedRoute
                            path="/miscellaneous/claims-dashboard/faqs"
                            component={ClaimsDashboardFaqs}
                            authenticator={this._authenticator}
                            redirectTo={"/login"}
                          /> */}
                        </div>
                      // </Drawer>
                    )}
                    {who && who === "EMPLOYEE" && (
                      <div className="container-main">
                      {/* // <ProtectedRoute
                      //   path="/patient/:patientId/document/:folder/:startIndex"
                      //   component={DocViewer}
                      //   authenticator={this._authenticator}
                      //   redirectTo={"/login"}
                      // /> */}
                      </div>
                    )}
                  </div>
                </Route>
              </Switch>
              <GlobalError />
            </div>
        </Router>
      </div>
    );
  }
  _authenticator = () => {
    return this.authenticationService.isLoggedIn();
  };

  _reverseAuthenticator = () => {
    return !this.authenticationService.isLoggedIn();
  };
}

export default App;
